import React from "react";
import { Button, Dropdown, Modal, Menu, Tooltip } from "antd";
import {
  DashOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import ee from "services/EventEmitter";
import { DELETE_FILE_MESSAGE, MODAL } from "constants/translates";

interface DownloadFileProps {
  documents: string;
  id?: string | number;
  deleteFile?: boolean;
  downloadEventId: string;
  deleteEventId: string;
}

interface FileLinkProps {
  documentName: string;
}

export const AttachedFile = ({
  documents,
  id,
  deleteFile = false,
  downloadEventId,
  deleteEventId,
}: DownloadFileProps): JSX.Element => {
  if (!documents) {
    return <></>;
  }

  const documentNames = documents?.split(";");

  const downloadCurrentFile = (documentName: string) => {
    ee.emit(downloadEventId, { documents: documentName, id });
  };

  const deleteCurrentFile = (documentName: string) => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: DELETE_FILE_MESSAGE(documentName),
      onOk: () => {
        ee.emit(deleteEventId, {
          documents: documentName,
          id,
        });
      },
    });
  };

  const IconComponent = () =>
    deleteFile ? <DeleteOutlined /> : <PaperClipOutlined />;

  const onClick = deleteFile ? deleteCurrentFile : downloadCurrentFile;

  const FileLink = ({ documentName }: FileLinkProps) => {
    return (
      <div className={deleteFile ? "delete-link" : "download-link"}>
        {documentName}
        <IconComponent />
      </div>
    );
  };

  const documentMenu = () => {
    return (
      <Menu>
        {documentNames?.map((documentName, index) => {
          return (
            <React.Fragment key={index}>
              {index > 1 && (
                <Menu.Item key={index} onClick={() => onClick(documentName)}>
                  <FileLink documentName={documentName} />
                </Menu.Item>
              )}
            </React.Fragment>
          );
        })}
      </Menu>
    );
  };

  const FilesAsList = () => {
    return (
      <Dropdown overlay={documentMenu}>
        <Button type="primary" style={{ minWidth: "25px" }}>
          <DashOutlined />
        </Button>
      </Dropdown>
    );
  };

  const extendedString = documentNames?.length > 2;

  return (
    <div className="upload-files-wrapper">
      <div className="download-files">
        {documentNames?.map((documentName, index) => {
          const extendedCondition = extendedString
            ? 1
            : documentName?.length - 1;

          return (
            <React.Fragment key={index}>
              {!(index > extendedCondition) && (
                <div key={index}>
                  <Button
                    onClick={() => onClick(documentName)}
                    type="link"
                    color="black"
                    className="file-wrapper"
                    style={{
                      color: "black",
                    }}
                  >
                    <FileLink documentName={documentName} />
                  </Button>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="upload-files-container">
        {extendedString && <FilesAsList />}

        {documentNames?.length > 0 && !deleteFile && (
          <>
            &nbsp;
            <Tooltip placement="top" title="Download all">
              <Button
                type="primary"
                style={{ minWidth: "25px" }}
                onClick={() => downloadCurrentFile("all")}
              >
                <DownloadOutlined />
              </Button>
            </Tooltip>
          </>
        )}
      </div>
    </div>
  );
};
